import {createRequest} from "../submodules/naoo-web-components/Api/createRequest";

const getTags = (params) => createRequest('main', 'get', '/tags', null, params)

export { getTags }